module.exports = __webpack_public_path__ + "img/license_image10.98830f82.png";